import { Role } from "@/role";

type NavItem = {
  route: { name: string };
  text: string;
};

const items: { [key: string]: NavItem[] } = {
  [Role.Admin]: [
    {
      route: { name: "home" },
      text: "Home",
    },
    {
      route: { name: "candidates" },
      text: "Candidates",
    },
    {
      route: { name: "contacts" },
      text: "Contacts",
    },
    {
      route: { name: "categories" },
      text: "Categories",
    },
    {
      route: { name: "tags" },
      text: "Tags",
    },
    {
      route: { name: "exports" },
      text: "Exports",
    },
    {
      route: { name: "reports" },
      text: "Reports",
    },
    {
      route: { name: "settings" },
      text: "Settings",
    },
    {
      route: { name: "announcements" },
      text: "Announcements",
    },
    {
      route: { name: "graphics" },
      text: "Graphics",
    },
    {
      route: { name: "products" },
      text: "Products",
    },
    {
      route: { name: "users" },
      text: "Users",
    },
  ],
  [Role.Candidate]: [
    {
      route: { name: "home" },
      text: "Home",
    },
    {
      route: { name: "candidate-logo" },
      text: "Logo",
    },
    {
      route: { name: "sponsorships" },
      text: "Sponsorships",
    },
    {
      route: { name: "voter-rewards" },
      text: "Voter Rewards",
    },
    {
      route: { name: "awards-ceremony" },
      text: "Awards Ceremony",
    },
    {
      route: { name: "plaques" },
      text: "Plaques",
    },
    {
      route: { name: "magazine" },
      text: "Magazine",
    },
    {
      route: { name: "graphics" },
      text: "Graphics",
    },
    {
      route: { name: "accounting" },
      text: "Accounting",
    },
  ],
  [Role.Unauthorized]: [],
};

export default items;
